import React from "react";
import { Helmet } from "react-helmet-async";

export default function Contact() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Helmet>
        <title>Contact – OjoVest</title>
        <link rel="canonical" href="https://www.ojovest.com/contact" />
      </Helmet>

      <div className="mx-auto max-w-4xl px-4 py-12">
        <h1 className="text-3xl font-semibold tracking-tight">Contact</h1>
        <p className="mt-4 text-sm text-slate-700">
          Email: <a className="underline" href="mailto:support@ojovest.com">support@ojovest.com</a>
        </p>
        <p className="mt-2 text-sm text-slate-700">
          Phone: <a className="underline" href="tel:+919999999999">+91 99999 99999</a>
        </p>
      </div>
    </div>
  );
}
